<div class="tab-head shared-table-toolbar">
    <ng-content select="[toolbarLeading]"></ng-content>
    <ng-content select="[toolbarSearch]"></ng-content>
    <ng-content select="[toolbarFilters]"></ng-content>
    <ng-content select="[toolbarTrailing]"></ng-content>
</div>
